import { common as zhCommon } from './zh/common';
import { home as zhHome } from './zh/home';

export default {
  zh: {
    common: zhCommon,
    home: zhHome,
  },
};